import React from "react";

import { faPlug } from "@fortawesome/pro-regular-svg-icons";

import { useManifestCatalog } from "src/api/connectApi/queries";
import { CustomIcon } from "src/connections/config/CustomIcon";
import { NodeIcon, NodeIconSize } from "src/design-system/NodeIcon";
import { useWorkspaceAndOrg } from "src/utils/useCurrentWorkspace";

type Props = {
  provider: string;
  size: NodeIconSize;
};

export const ManifestIcon: React.FC<Props> = ({ provider, size }) => {
  const workspaceData = useWorkspaceAndOrg();
  const catalogEntry = useManifestCatalog(
    workspaceData.workspace?.base_url,
  ).data?.find((entry) => entry.name === provider);

  // S3-promoted manifests store the logo as an S3 media_key (flattened into
  // the catalog entry). GitHub-promoted manifests commit the logo as a file
  // referenced by icon_path. Pick the right source.
  if (catalogEntry?.media_key) {
    return <CustomIcon size={size} mediaKey={catalogEntry.media_key} />;
  }

  // If there's no icon specified in the manifest, default to the CC default one
  if (!catalogEntry?.icon_path) {
    return <NodeIcon icon={faPlug} size={size} />;
  }

  return (
    <NodeIcon
      alt={`${provider} Icon`}
      dataLoc={`${provider}-icon`}
      imageSrc={catalogEntry.icon_path}
      size={size}
    />
  );
};
